import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

/**
 * 
 * @param {object | Array} ref 
 * @returns {boolean}
 */
export function useHover(ref) {
     const [value, setValue] = useState(false)

    const handleMouseEnter = () => {
        setValue(true);
    }
    const handleMouseLeave = () => {
        setValue(false);
    }

    if (!Array.isArray(ref) && !ref.current) return false;

    useEffect(() => {
        if (Array.isArray(ref)) {
            ref.forEach(({current}) => {
                if (!!current) {
                    if (!isMobile) {
                        current.addEventListener('mouseenter', handleMouseEnter);
                        current.addEventListener('mouseleave', handleMouseLeave);
                    } else {
                        current.addEventListener('touchstart', handleMouseEnter);
                        current.addEventListener('touchend', handleMouseLeave);
                    }
                }
            });
        } else {
            if (!isMobile) {
                ref.current.addEventListener('mouseenter', handleMouseEnter);
                ref.current.addEventListener('mouseleave', handleMouseLeave);
            } else {
                ref.current.addEventListener('touchstart', handleMouseEnter);
                ref.current.addEventListener('touchend', handleMouseLeave);
            }
        }

        return () => {
            if (Array.isArray(ref)) {
                ref.forEach(({current}) => {
                    if (!!current) {
                        if (!isMobile) {
                            current.removeEventListener('mouseenter', handleMouseEnter);
                            current.removeEventListener('mouseleave', handleMouseLeave);
                        } else {
                            current.removeEventListener('touchstart', handleMouseEnter);
                            current.removeEventListener('touchend', handleMouseLeave);
                        }
                    }
                });
            } else {
                if (!isMobile) {
                    ref.current.removeEventListener('mouseenter', handleMouseEnter);
                    ref.current.removeEventListener('mouseleave', handleMouseLeave);
                } else {
                    ref.current.removeEventListener('touchstart', handleMouseEnter);
                    ref.current.removeEventListener('touchend', handleMouseLeave);
                }
            }
        }

    }, [ref, ref.current]);

    return value;
}
